import React, { Component } from 'react';
import PropTypes from 'prop-types';

import icons from '../../assets/icons';

import './Group.css';

const ESCAPE_KEY = 27;

class Group extends Component {
  static get propTypes() {
    return {
      group: PropTypes.shape({
        Id: PropTypes.number,
        Name: PropTypes.string,
        Active: PropTypes.bool,
        Users: PropTypes.arrayOf(PropTypes.shape({
          Id: PropTypes.number,
          Name: PropTypes.string
        }))
      }),
      allGroups: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string
      })),
      onUpdateGroup: PropTypes.func.isRequired
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      groupName: props.group.Name
    };
  }

  componentWillReceiveProps(props) {
    if (props.group.Name !== this.props.group.Name) {
      this.setState({
        groupName: props.group.Name
      });
    }
  }

  componentDidUpdate() {
    if (this.nameInput && this.nameInput !== document.activeElement) {
      this.nameInput.focus();
      this.nameInput.select();
    }
  }

  render() {
    const { group } = this.props;
    const { editing } = this.state;
    this.nameInput = null;

    return (<tr>
      <td className="name">{
        editing ? this.renderEditName() : this.renderName()
      }</td>
      <td className="active">{this.renderActiveCheck()}</td>
      <td className="users">{group.Users ? group.Users.length : 0}</td>
    </tr>);
  }

  renderName() {
    const { groupName } = this.state;

    return (<button
      className="AdminGroup-namelabel"
      onClick={() => this.startEditName()}
    >
      {groupName}
    </button>);
  }

  renderEditName() {
    const { groupName } = this.state;
    return (<form
      className="AdminGroup-editname"
      onSubmit={event => this.completeEditName(event)}
    >
      <input
        type="text"
        placeholder="New Group Name"
        className="AdminGroup-nameedit"
        value={groupName}
        ref={(input) => { this.nameInput = input; }}
        onBlur={() => !this.disableBlur && this.cancelEditName()}
        onChange={event => this.setState({ groupName: event.target.value })}
        onKeyDown={event => event.keyCode === ESCAPE_KEY && this.cancelEditName()}
      />
      <input
        type="submit"
        className="AdminGroup-editnamesubmit btn btn-submit"
        value="Save"
        onMouseDown={() => { this.disableBlur = true; }}
        onMouseUp={() => { this.disableBlur = false; }}
        disabled={!this.validateGroupName()}
      />
    </form>);
  }

  renderActiveCheck() {
    const { group } = this.props;
    const checkId = `checkbox-${group.Id}-group`;
    const checkImg = group.Active ? icons.blue.checkbox_on : icons.blue.checkbox_off;

    return (<div className="AdminGroup-active">
      <input
        type="checkbox"
        checked={group.Active}
        onChange={event => this.setGroupActive(event.target.checked)}
        id={checkId}
      /><label htmlFor={checkId}>
        <img className="checkImg" src={checkImg} alt="checkbox" />
      </label>
    </div>);
  }

  setGroupActive(checked) {
    const { group, onUpdateGroup } = this.props;
    onUpdateGroup(Object.assign({}, group, { Active: checked }));
  }

  startEditName() {
    this.setState({
      editing: true
    });
  }

  completeEditName(event) {
    const { group, onUpdateGroup } = this.props;
    const { groupName } = this.state;

    if (event) {
      event.preventDefault();
    }

    this.setState({
      editing: false
    });
    if (group.Name !== groupName) {
      onUpdateGroup(Object.assign({}, group, { Name: groupName }));
    }
  }

  cancelEditName() {
    const { group } = this.props;
    this.setState({
      editing: false,
      groupName: group.Name
    });
  }

  validateGroupName() {
    const { group, allGroups } = this.props;
    const { groupName } = this.state;

    const tryName = groupName.trim().toLowerCase();
    if (groupName.trim().length > 0) {
      if (tryName !== group.Name.toLowerCase() && allGroups) {
        return !allGroups.find(g => g.Name.toLowerCase() === tryName);
      }
      return true;
    }
    return false;
  }
}
export default Group;



// WEBPACK FOOTER //
// ./src/admin/groups/Group.js